import { useCallback } from 'react'
import type { PointerEvent } from 'react'

/**
 * Pointer handler for `.spotlight` surfaces: writes the cursor position into
 * `--mx`/`--my` so the CSS radial glow follows it. No React state, no re-render.
 */
export function useSpotlight() {
  return useCallback((e: PointerEvent<HTMLElement>) => {
    const el = e.currentTarget
    const rect = el.getBoundingClientRect()
    el.style.setProperty('--mx', `${e.clientX - rect.left}px`)
    el.style.setProperty('--my', `${e.clientY - rect.top}px`)
  }, [])
}
